import React, { Component } from 'react';
import { MAX_RATING } from '../../../constants'

import Rating from 'react-rating'

import './ratingStars.css'

let classNames = require('classnames'); 

class RatingStars extends Component {

  render() {
    const {
      showInfo,
      rating,
      ratingCount,
      noRatingInfoType,
      noInfoMessage,
      size,
      className,
      center,
      tripTotal
    } = this.props

    let ratingContainerClass = classNames('rating-container', this.props.className, {
      'zero-count' : ratingCount === 0,
    })

    let innerWrapClass = classNames('rating-stars-inner-wrap', this.props.className, {
      'center-alignment' : center,
    })

    return (
      <span className="rating-stars-info">
        {rating > 0 && <span className={ratingContainerClass + ' ' + size}>
          <span className={innerWrapClass}>

          <span className="rating-stars">
            <Rating
              fractions={2} 
              emptySymbol="fas fa-star twisted-empty-star"
              fullSymbol="fas fa-star twisted-full-star"
              readonly
              className={className}
              initialRating={rating}
              start={0}
              stop={MAX_RATING}
            />
          </span>

          {showInfo && (
            <span className="rating-info">
              {ratingCount > 0 && (
                <span>&nbsp;{"("+ratingCount+")"}</span>
              )}
              {ratingCount === 0 && (
                <span>
                  {noRatingInfoType === 'message' && (                  
                    <span>{noInfoMessage} </span>
                  )}
                </span>
              )}
            </span>
          )}
          </span>
        </span>}
        {showInfo && (
          <div className={"trip-taken-count" + '-' + size}>
            {tripTotal === 1 ? " (" + tripTotal.toString() + " trip taken)" : null}
            {tripTotal > 1 ? " (" + tripTotal.toString() + " trips taken)" : null}
          </div>
        )}
      </span>
    )
  }
}
export default RatingStars

RatingStars.defaultProps = {
  showInfo : true,
  rating: 0,
  ratingCount : 0,
  noRatingInfoType : 'count', //or can also be message
  noInfoMessage : 'No ratings, yet.',
  size: 'small',
  className : '',
  center : false
}